import { motion } from "framer-motion";
import ScrollAnimation from "../../../hooks/ScrollAnimation";

const ProfileHero = ({ userData }) => {
  return (
    <section className="relative isolate overflow-hidden text-white py-24 md:py-32 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700">
      {/* Animated Background */}
      <div className="absolute inset-0 -z-30 animate-[gradientMove_16s_ease_infinite] bg-[linear-gradient(120deg,#1e3a8a_0%,#1d4ed8_50%,#2563eb_100%)] bg-[length:200%_200%] opacity-95" />

      {/* Light Orbs */}
      <div className="pointer-events-none absolute inset-0 -z-20">
        <span className="ball absolute left-[8%] top-[18%]" />
        <span className="ball absolute right-[12%] top-[28%] delay-300" />
        <span className="ball-sm absolute left-[16%] bottom-[20%] delay-700" />
        <span className="ball-sm absolute right-[24%] bottom-[26%] delay-500" />
        <span className="ball-sm absolute left-[32%] top-[36%] delay-1000" />
      </div>

      {/* Soft Glows */}
      <div
        aria-hidden
        className="absolute -top-40 -left-40 h-[36rem] w-[36rem] rounded-full bg-white/10 blur-3xl -z-10"
        style={{
          maskImage: "radial-gradient(closest-side, white, transparent)",
        }}
      />
      <div
        aria-hidden
        className="absolute -bottom-32 -right-32 h-[34rem] w-[34rem] rounded-full bg-white/10 blur-3xl -z-10"
        style={{
          maskImage: "radial-gradient(closest-side, white, transparent)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollAnimation direction="up" delay={0.1}>
          <div className="text-center">
            <motion.div
              className="inline-flex items-center gap-2 mb-5 rounded-full border border-white/20 bg-white/10 px-5 py-2 backdrop-blur-md"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              <span className="h-2 w-2 rounded-full bg-emerald-400 animate-[pingSlow_2.4s_linear_infinite]" />
              <span className="text-sm font-semibold text-white/90">
                {userData.isLawFirm ? "Law Firm Dashboard" : "User Profile"}
              </span>
            </motion.div>

            <motion.h1
              className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-[0_6px_24px_rgba(0,0,0,.35)]"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.6 }}
              style={{
                background:
                  "linear-gradient(180deg, #ffffff 0%, #e2e8f0 60%, rgba(255,255,255,.9) 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Welcome, {userData.name}
            </motion.h1>

            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ delay: 0.45, duration: 0.7 }}
              className="relative mx-auto mt-4 h-[3px] w-48 origin-center rounded-full bg-gradient-to-r from-cyan-300 via-white to-blue-300 shadow-[0_0_18px_rgba(255,255,255,.6)] overflow-hidden"
            >
              <div className="absolute inset-0 shimmer opacity-80" />
              <div className="absolute -inset-1 bg-white/40 blur-md glowPulse rounded-full" />
            </motion.div>

            <motion.p
              className="text-xl text-blue-100 max-w-2xl mx-auto mt-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.6 }}
            >
              {userData.isLawFirm
                ? `Manage your law firm, lawyers, and client requests with your ${userData.subscriptionType} subscription.`
                : "Manage your immigration forms, lawyers, and payments all in one place."}
            </motion.p>
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
};

export default ProfileHero;
